import styled, { css } from 'styled-components';

import { typeLabel01 } from './typography'
import { unit, mediaQuery, SIZE } from './metrics'


export const button = css`
	${typeLabel01}
	text-decoration: none;
	outline: none;
	border: none;
	white-space: nowrap;
	line-height: ${unit(6)};
	height: ${unit(6)};
	padding: 0 ${unit(3)};
	text-align: center;
`